import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { ChainWideCradlepointsComponent } from '@app/features/cradlepoints/modules/chain-wide-cradlepoints/chain-wide-cradlepoints.component';
import { Authority } from '@app/shared/utils/enums';

export const chainWideCradlepointsRoutes: Routes = [
    {
        path: 'chain-wide-cradlepoints',
        children: [
            {
                path: '',
                component: ChainWideCradlepointsComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.UPDATE]
                },
                canActivate: [RouteAccessGuard]
            }
        ]
    }
]